import { makeAutoObservable } from 'mobx';
import SearchBrowserFilterState from './SearchBrowserFilterState';
import SearchFilterState from './SearchFilterState';
import SearchResultsState from './SearchResultsState';

class SearchMainState {
  constructor() {
    makeAutoObservable(this);
  }

  isFilterOpen = false;

  isInitialized = false;

  toggleFilter() {
    this.isFilterOpen = !this.isFilterOpen;
  }

  setFilterIsOpen(v) {
    this.isFilterOpen = v;
  }

  *init({ userLocationState }) {
    this.userLocationState = userLocationState;

    try {
      if (!this.userLocationState.isInitialized) {
        yield this.userLocationState.getLocation();
      }
    } catch (e) {
      console.warn("Can't get user location");
    }

    this.searchBrowserFilterState = new SearchBrowserFilterState();
    this.searchFilterState = new SearchFilterState();
    this.searchResultsState = new SearchResultsState();

    this.searchBrowserFilterState.init(this);
    this.searchFilterState.init(this);
    this.searchResultsState.init(this);

    this.isInitialized = true;
  }

  destroy() {
    this.isInitialized = false;
    this.searchResultsState?.destroy();
    this.searchFilterState?.destroy();
    this.searchBrowserFilterState?.destroy();
  }
}

const state = new SearchMainState();
const useSearchMainState = () => state;
const useSearchBrowserFilterState = () => state.searchBrowserFilterState;
const useSearchFilterStateState = () => state.searchFilterState;
const useSearchResultsState = () => state.searchResultsState;

export default state;
export {
  useSearchMainState,
  useSearchBrowserFilterState,
  useSearchResultsState,
  useSearchFilterStateState,
};
